import { render, staticRenderFns } from "./DetailedItemView.vue?vue&type=template&id=7864dc22&scoped=true&"
import script from "./DetailedItemView.vue?vue&type=script&lang=ts&"
export * from "./DetailedItemView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7864dc22",
  null
  
)

export default component.exports